import type { ReactNode } from "react";

/** Help for someone clicking through a mock-up (which addresses to try, the code that works). It sits fixed at the
 *  bottom of the window, outside the screen, and is never part of a real page. */
export function MockUpHelp({ children }: { children: ReactNode }) {
  return (
    <aside className="fixed inset-x-0 bottom-0 z-50 border-t border-dashed bg-amber-50 px-4 py-2 text-center text-xs text-amber-900">
      <span className="font-semibold">Mock-up only:</span> {children}
    </aside>
  );
}
